import { MsalProvider } from '@azure/msal-react'

import { ReactNode, useEffect, useState } from 'react'

import { escucharLogoutDeOtrasPestanas } from './logout'
import { getMsalInstance, initializeMsal } from './msal'

import { Loading } from '@/common/components/Loading'
import { EPublicRoutes } from '@/common/constants/routes/public.routes'

interface IMsalCustomProviderProps {
  children: ReactNode
}

const MsalCustomProvider: React.FC<IMsalCustomProviderProps> = ({
  children,
}) => {
  // MsalCustomProvider se monta DENTRO de ConfigRuntimeProvider, que bloquea el render
  // hasta hidratar /api/config. Por eso acá CLIENT_ID/API_SCOPE ya están disponibles y
  // getMsalInstance() crea la instancia real con la config correcta del ambiente.
  const [instance] = useState(() => getMsalInstance())
  const [msalListo, setMsalListo] = useState(false)

  // MsalProvider se monta recién cuando initializeMsal() hizo la primera llamada a
  // handleRedirectPromise (sin navegar, ver msal.ts). Si se montara antes, su efecto corre
  // primero —los efectos del hijo van antes que los del padre— y su llamada sin opciones es la
  // que MSAL guarda: vuelve el bucle HOME ↔ login.
  useEffect(() => {
    initializeMsal().finally(() => setMsalListo(true))
  }, [])

  // Logout en OTRA pestaña: acá solo se purga el cache y se sale de la ruta privada. La sesión de
  // Entra ya la cerró la pestaña que inició el logout.
  //
  // El aviso de la propia pestaña no llega hasta acá: lo filtra `escucharLogoutDeOtrasPestanas`,
  // porque BroadcastChannel reparte a los demás canales del MISMO contexto y este handler
  // competía con el logoutRedirect en vuelo.
  //
  // Ojo con el cache: `authConfig` usa `cacheLocation: 'localStorage'`, así que es COMPARTIDO
  // entre pestañas, no uno por pestaña. Este `clearCache()` toca el de todas.
  useEffect(
    () =>
      escucharLogoutDeOtrasPestanas(() => {
        instance.clearCache().finally(() => window.location.assign(EPublicRoutes.AUTENTICACION))
      }),
    [instance],
  )

  if (!msalListo) {
    return <Loading />
  }

  return <MsalProvider instance={instance}>{children}</MsalProvider>
}

export default MsalCustomProvider
